import React, { useState, useEffect } from "react";
import "../Lp.css";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useHistory } from "react-router";
import { FaUserCircle, FaMapPin, FaWhatsappSquare } from "react-icons/fa";
import { RiWhatsappFill } from "react-icons/ri";
//IMPORTING ACTIONS FOR REEDUX API CALL
import { getCity, getCall } from "../../../Redux/Actions";
import { Modal } from "react-responsive-modal";

const LpFormDisplay = ({
  position,
  butname,
  title,
  formId,
  isLp,
  isImagine,
  buttonId,
  lpNumber,
}) => {
  const [userName, setUserName] = useState("");
  const [number, setNumber] = useState("");
  const [userNumber, setUserNumber] = useState("");
  const [userCity, setUserCity] = useState("");
  const [nameError, setNameEror] = useState("");
  const [phoneError, setPhoneEror] = useState("");
  const [displayCityList, setDisplay] = useState(true);
  const [success, setSucess] = useState(false);
  const [checkboxState, setCheckboxState] = useState(true);
  const [disable, setDisable] = useState(true);
  const [openSuccModel, setSucc] = useState(false);
  const [Captcha, setCaptcha] = useState("");
  const [InputCaptcha, setInputCaptcha] = useState("");
  const [errorCaptcha, setErrorCaptcha] = useState("");

  const history = useHistory();
  
  console.log(Captcha, "Now");

  useEffect(() => {
    const RandomCharGen = () => {
      const char = ["r", "e", "d", "c", "i", "f", "e"];
      const position = Math.floor(Math.random() * char.length);
      return char[position];
    };

    const RandomNumGen = () => {
      const num = Math.floor(Math.random() * 10);
      return num;
    };

    const captchGenrator = (len) => {
      let randomText = "r";
      while (randomText.length <= len) {
        randomText =`${randomText}${RandomCharGen()}${RandomNumGen()}`;
      }
      return randomText;
    };
    setCaptcha(captchGenrator(4));
  }, []);

  useEffect(() => {
    // if (isImagine) {
    //   setNumber("898 898 0606");
    // } else if (isLp && lpNumber) {
    //   setNumber(lpNumber);
    // } else {
    //   setNumber("898 898 8787");
    // }

    isImagine ? setNumber("898 898 0606") : isLp && lpNumber ? setNumber(lpNumber) : setNumber("898 898 8787")
  }, [isImagine]);
  //cont
  const openSucess = () => setSucc(true);
  const closeSuccess = () => setSucc(false);

  useEffect(() => {
    if (
      userName == "" ||
      userCity == "" ||
      userNumber == "" ||
      InputCaptcha == "" ||
      !errorCaptcha == ""
    ) {
      setDisable(true);
    } else {
      setDisable(false);
    }
  }, [userName, userCity, userNumber, InputCaptcha, errorCaptcha]);
  //calling city name api
  useEffect(() => {
    dispatch(getCity());
  }, []);

  //comment
  //GETTING DATA FROM STORE (CITIES NAME) STARTS HERE
  const navCity = useSelector((state) => state.navCityList);
  const { navCities } = navCity;
  const citiesFromArray = navCities;

  const cityList = useSelector((state) => state.cityList);
  const { cities, loading } = cityList;

  const dispatch = useDispatch();

  //   const handelCityChange = (e) => {
  //     document.getElementById("cityList").classList.remove("displayNone");

  //     userCity(e.target.value);
  //   };
  //use location imported
  const location = useLocation();
  ///${position}

  var url = `https://redcliffelabs.com${location.pathname}/${
    position ? position : ""
  }/${location.search}`;

  //var url = `https://redcliffelabs.com${location.pathname}/${position}`;

  //HANDEL USERNAME FUNCTON BELOW THIS COMMENT
  const handelUserName = (e) => {
    setUserName(e.target.value);
    const characterRegex =/^([A-Za-z]+[ ]?)+$/;
    setNameEror("");
    if (!e.target.value.match(characterRegex)) {
      setNameEror("invalid user name");
    }
    if (e.target.value == "") {
      setNameEror("");
    }
  };

  //HANDEL USEPHONE FUNCTION BELOW THIS COMMENT 2
  const validatePhoneNumber = () => {
    let phoneno = /^\d{10}$/;
    if (!userNumber.match(phoneno) || parseInt(userNumber[0]) < 6) {
      setPhoneEror("Enter a valid number");
      return false;
    } else {
      return true;
    }
  };

  const handleCheckChange = (e) => {
    setCheckboxState(!checkboxState);
  };

  const handleCaptcha = (e) => {
    setInputCaptcha(e.target.value);
    if (e.target.value !== Captcha) {
      setErrorCaptcha("Invalid Captcha");
    } else {
      setErrorCaptcha("");
    }
  };
  //HANDEL USEPHONE FUNCTION BELOW THIS COMMENT 1
  const handelPhoneChange = (e) => {
    setUserNumber(e.target.value);
    setPhoneEror("");
  };

  const handelSubmit = (e) => {
    e.preventDefault();
    const checkVal = validatePhoneNumber();
   
    if (checkVal) {
      const body = {
        optin: checkboxState,
        name: userName,
        phone_no: userNumber,
        source: "Google_lp-Display",
        city: userCity,
        url,
      };
      console.log(body);
      setUserNumber("");
      setUserName("");
      setUserCity("");
      setErrorCaptcha("");
      setInputCaptcha("");
      setSucess(true);
      openSucess(true);
      setTimeout(() => {
        setSucess(false);
      }, 2000);
      dispatch(getCall(body));
     
    }
  };

  const setInputcity = (val) => {
    setUserCity(val);
    setDisplay(false);
  
  };

  const handelCityChange = (e) => {
    setUserCity(e.target.value);
    setDisplay(true);
    
  };
  //model div
  const SuccessModel = ({ number }) => {
    return (
      <div className="SuccessMsg_upload">
        <h2>
          We have received your information. We shall call you in few minutes to
          confirm the details. For any queries please call us at &nbsp;
          <a href={`tel:+91-${number}`} style={{ color: "blue" }}>
            {number}
          </a>{" "}
          - Team Redcliffe Labs
        </h2>
      </div>
    );
  };

  return (
    <form onSubmit={handelSubmit}
    id={formId ? formId : "normalForm"} 
    >
      <div className="form__div">
        {/* <h4>Book Your Test</h4> */}
        {isLp ? null : <h4>{title ? title : "Book Your Test"}</h4>}
        <div>
          <div className="form__input numBox">
            <span className="userIcon">
              <FaUserCircle />
            </span>
            <div className="inputDiv">
              <input
                style={{border:'none'}}
                type="text"
                placeholder="Enter Name"
                onChange={handelUserName}
                value={userName}
              />
            </div>
          </div>
          <span className="FormError">{nameError}</span>
        </div>

        {/* <div className="phone_number">
                    +91 */}
        <div>
          <div className="form__input numBox">
            <span className="numIcon">+91</span>
            <div className="inputDiv">
              <input
                onBlur={()=>{validatePhoneNumber()}}
                style={{border:'none'}}
                type="text"
                placeholder="Enter Phone Number"
                required
                onChange={handelPhoneChange}
                value={userNumber}
              />
            </div>
          </div>
          <span className="FormError">{phoneError}</span>
        </div>
        {/* </div>   */}
        <div className="citySelect">
          <span className="locIcon">
            {" "}
            <FaMapPin />{" "}
          </span>

          <input
            // style={{border:'none'}}
            type="text"
            placeholder="Enter City"
            onChange={handelCityChange}
            value={userCity}
          />

          {/* <AiFillCaretDown /> */}
          {/**CITY LIST ARRAY BELOW */}
          <div className={userCity ? "cityList" : "displayNone"} id="cityList">
            {userCity !=="" && citiesFromArray && citiesFromArray.cities
              ? citiesFromArray.cities
                  .filter((name) => {
                    if (userCity == "") {
                      return name;
                    } else if (
                      name.toLowerCase().includes(userCity.toLowerCase())
                    ) {
                      return name;
                    }
                  })
                  .map((values, index) => {
                    if (index < 2) {
                      return (
                        <>
                          <div
                            onClick={() => setInputcity(values)}
                            key={index}
                            className={
                              displayCityList ? "cityLIstLP" : "displayNone"
                            }
                          >
                            <span>{values}</span>
                          </div>

                          {/* <div
                              className="cityItem"
                              key={index}
                              onClick={() => setCity(filteredName)}
                            >
                              {" "}
                              <span>{filteredName}</span>{" "}
                            </div> */}
                        </>
                      );
                    }
                  })
              : null}
          </div>
        </div>
        <div style={{ marginTop: "2rem" }}>
          <div className="form__input numBox">
            <span
              className="numIcon"
              style={{
                color: "rgb(40, 92, 139)",
                fontWeight: "500",
                fontFamily: "emoji",
                margin: "1rem",
                width: "60px",
                textDecoration: "line-through",
              }}
            >
              {Captcha}
            </span>
            <div className="inputDiv">
              <input
                style={{border:'none'}}
                type="text"
                placeholder="Enter Captcha"
                required
                onChange={handleCaptcha}
                value={InputCaptcha}
              />
            </div>
          </div>
          <span className="FormError">{errorCaptcha}</span>
        </div>
        {/* <div>
          <h2>{Captcha}</h2>
          <div className="form__input numBox">
            <div className="inputDiv">
              <input
                type="text"
                placeholder="Enter Captcha"
                required
                onChange={handleCaptcha}
                value={InputCaptcha}
              />
            </div>
          </div>
          <span className="FormError">{errorCaptcha}</span>
        </div> */}
        <div className="LP_opt_Div">
          <input
            
            type="checkbox"
            onChange={() => handleCheckChange()}
            defaultChecked
            style={{ width: "22px", height: "22px" , border:'none' }}
          />
          <span className="watsap">
            <RiWhatsappFill className="wtsapIcon" />
          </span>
          <span className="textt">Opt-in for WhatsApp updates </span>
        </div>

        {/* <span className="successMsg">
          {
          success && isLp ? "success" : success ? "Your Form  has been submitted successfully!" : null}
          
          </span> */}

        <button
         
          id={buttonId ? buttonId : "normalButton"}
          type="submit"
          disabled={
            isLp
              ? nameError || disable
                ? "disabled"
                : ""
              : nameError
              ? "disabled"
              : ""
          }
          className={
            isLp
              ? nameError || disable
                ? "disabled"
                : ""
              : nameError
              ? "disabled"
              : ""
          }
        >
          {butname ? butname : "SUBMIT"}
        </button>
      </div>
      <Modal open={openSuccModel} onClose={closeSuccess} center>
        <SuccessModel number={number} />
      </Modal>
    </form>
  );
};

export default LpFormDisplay;
